import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missions-details',
  templateUrl: './missions-details.component.html',
  styleUrls: ['./missions-details.component.scss']
})
export class MissionsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
